import { useState } from 'react';
import { client as api } from '../services/api';
import { Order } from '../types/types';
import { useSchedule } from '../context/ScheduleContext';

export const useFetchOrder = () => {
  const [order, setOrder] = useState<Order | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [statuses, setStatuses] = useState<Record<string, boolean>>({});
  const { setData } = useSchedule();

  const executeFetch = async (fetchFn: () => Promise<any>) => {
    setLoading(true);
    setError(undefined);
    try {
      const response = await fetchFn();
      const orderData = Array.isArray(response.data) ? response.data : [response.data];
      setOrder(orderData);
      await checkScheduledOrder(orderData);
    } catch (error) {
      console.error('Erro ao buscar pedidos:', error);
      setError(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderByEcommerceId = async (ecommerceId: string) => {
    setData(prevState => ({
      ...prevState,
      pedidoEcommerce: ecommerceId
    }));
    await executeFetch(() => 
      api.get(`/agendamento/buscarpedidogar/${ecommerceId}`)
    );
  };

  const fetchOrderByGarDocument = async (garId: string, document: string) => {
    if (!garId || !document) {
      setError("Número do pedido GAR e Documento são obrigatórios.");
      setLoading(false);
      return;
    }
    await executeFetch(() => 
      api.get(`/agendamento/pedido-gar/${garId}?document=${document}`)
    );
  };

  const checkScheduledOrder = async (orders: Order[]) => {
    const statusMap: Record<string, boolean> = {};
    const flatOrders = orders.flat();

    try {
      await Promise.all(
        flatOrders.map(async (order) => {
          const response = await api.get(`/agendamento/status/${order.id}`);
          statusMap[order.id] = response.data.status?.descricao === "Agendado";
        })
      );
      setStatuses(statusMap);
    } catch (error) {
      console.error('Erro ao buscar status dos pedidos:', error);
    }
  };

  return { order, loading, error, fetchOrderByEcommerceId, fetchOrderByGarDocument, statuses, setStatuses };
};
